import React from 'react';
import ReactDOM from 'react-dom/client';
import { findUpwardsByTag, isElementOneOf } from '@crystaldelta/loree-util-dom';
import { LinkInfo } from './linkInfo';
import { Floater } from './floater';
import { Editor } from '@tiptap/react';
import { removeLink } from '../editor/editorExtensions/utilityFunctions';
import { CONSTANTS } from '../editor/editorUtilityFunctions/constants';
import ImageOptions from './imageOptionsModal';
import AudioOptions from './audioOptionsModal';
let removalFunction = () => {
  return;
};

export function hideLinkInfoPopup() {
  removalFunction();
  removalFunction = () => {
    return;
  };
}

export function showLinkInfoPopup(
  referenceElement: HTMLElement,
  onRemove: () => void,
  url: string,
  elementType: string,
  editor: Editor,
  popperID: string,
  target: string,
) {
  let div = document.getElementById(CONSTANTS.EDITOR_POPPER);
  const container = document.getElementById(popperID);
  if (!div && container) {
    container.innerHTML = `<div id='${CONSTANTS.EDITOR_POPPER}'></div>`;
    div = document.getElementById(CONSTANTS.EDITOR_POPPER);
  }
  const root = ReactDOM.createRoot(div as HTMLDivElement);

  removalFunction = () => {
    if (div) {
      root.unmount();
      div.remove();
    }
  };

  root.render(
    <>
      {elementType !== 'image' && elementType !== 'audio' && (
        <Floater
          referenceElement={referenceElement}
          onClose={hideLinkInfoPopup}
          placement='bottom'
          noBackground
          className='linkInfo'
          arrow
          gap={10}
          component={<LinkInfo onRemove={onRemove} url={url} target={target} />}
          editor={editor}
        />
      )}
      {elementType !== 'text' && elementType !== 'audio' && (
        <Floater
          referenceElement={referenceElement}
          onClose={hideLinkInfoPopup}
          placement='top'
          noBackground
          className='linkInfo'
          arrow
          gap={10}
          component={<ImageOptions editor={editor} />}
          editor={editor}
        />
      )}
      {elementType === 'audio' && (
        <Floater
          referenceElement={referenceElement}
          onClose={hideLinkInfoPopup}
          placement='top'
          noBackground
          className='linkInfo'
          arrow
          gap={10}
          component={<AudioOptions editor={editor} />}
          editor={editor}
        />
      )}
    </>,
  );
}

const isAudioElement = (targetElement: HTMLElement | null, nodeType: string) =>
  targetElement?.tagName === 'AUDIO' ||
  (targetElement?.querySelector('audio') !== null && nodeType === 'iframe');
const getAudioReferenceElement = (targetElement: HTMLElement) =>
  targetElement.tagName === 'AUDIO'
    ? targetElement
    : targetElement.querySelector('audio') ?? targetElement;

const resolveElementTypeAndReference = (
  targetElement: HTMLElement,
  anchorElement: HTMLAnchorElement | null,
  isAudio: boolean,
  nodeType: string,
  editor: Editor,
) => {
  if (nodeType === 'image' || editor.isActive('iconTag')) {
    return {
      elementType: anchorElement ? 'imageWithLink' : nodeType,
      referenceElement: targetElement,
    };
  }
  if (isAudio) {
    return { elementType: 'audio', referenceElement: getAudioReferenceElement(targetElement) };
  }
  return { elementType: 'text', referenceElement: anchorElement };
};

const handleLinkRemoval = (editor: Editor, nodeType: string) => {
  hideLinkInfoPopup();
  if (nodeType !== 'image' && !editor.isActive('iconTag')) {
    removeLink(editor);
    return;
  }
  editor.commands.removeLinkFromNode();
};

export function showLinkDetails(
  targetElement: HTMLElement | null,
  editor: Editor,
  nodeType: string,
  popperID: string,
) {
  const tags = ['P', 'SPAN', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'IMG', 'LI', 'UL', 'OL'];
  const anchorElement: HTMLAnchorElement | null = findUpwardsByTag(targetElement, 'a');
  const isImage = targetElement?.tagName === 'IMG';
  const isAudio = false; // isAudioElement(targetElement, nodeType);
  const isText = anchorElement && nodeType !== 'image';
  hideLinkInfoPopup();
  if (!targetElement) {
    return;
  }
  if (!isText && !isImage && !isAudio) {
    if (isElementOneOf(targetElement, tags)) {
      hideLinkInfoPopup();
    }
    return;
  }

  const { elementType, referenceElement } = resolveElementTypeAndReference(
    targetElement,
    anchorElement,
    isAudio,
    nodeType,
    editor,
  );

  if (!referenceElement) return;
  showLinkInfoPopup(
    referenceElement,
    () => handleLinkRemoval(editor, nodeType),
    anchorElement?.getAttribute('href') ?? '',
    elementType,
    editor,
    popperID,
    anchorElement?.target as string,
  );
}
